import React from "react";
import { Headphones } from "lucide-react";
import { WebViewTooltip } from "../../../Pages/Diary/SubHeader/WebViewTooltip";

interface SupportToggleButtonProps {
  isVisible: boolean;
  onToggle: () => void;
  collapsed?: boolean;
}

export const SupportToggleButton: React.FC<SupportToggleButtonProps> = ({
  isVisible,
  onToggle,
  collapsed = false
}) => {
  const buttonLabel = isVisible ? "Hide Support" : "Show Support";

  const button = (
    <button
      className="support-toggle-button w-full flex items-center gap-3 py-2 px-1 rounded-lg bg-transparent border-none cursor-pointer transition-all duration-200 ease-in-out text-left text-[#4b5563] hover:bg-[#f3f4f6] focus-visible:outline-2 focus-visible:outline-[var(--focus-ring-color,#1fd4d4)] focus-visible:outline-offset-2"
      onClick={onToggle}
      aria-label={buttonLabel}
      aria-pressed={isVisible}
      type="button"
    >
      <div className="support-toggle-button__icon shrink-0 flex items-center justify-center">
        <Headphones size={20} />
      </div>
      {!collapsed && (
        <span className="support-toggle-button__label text-sm font-medium whitespace-nowrap overflow-hidden text-ellipsis">
          {buttonLabel}
        </span>
      )}
    </button>
  );

  if (collapsed) {
    return (
      <WebViewTooltip content={buttonLabel} side="right" sideOffset={8}>
        {button}
      </WebViewTooltip>
    );
  }

  return button;
};
